module.exports = __webpack_public_path__ + "img/gartentor.8ff6c95a.jpg";